export type TermsDocumentIcon = 'lock' | 'shield' | 'key' | 'mask';

export type TermsDocument = {
	id: string;
	label: string;
	url: string;
	icon: TermsDocumentIcon;
};

export const TERMS_DOCUMENTS: TermsDocument[] = [
	{
		id: 'service-agreement',
		label: 'Соглашение об использовании сервиса',
		url: 'https://files.rocketwork.ru/roketwork/Soglashenie_Rocket_Work.pdf',
		icon: 'lock',
	},
	{
		id: 'personal-data-policy',
		label: 'Политика обработки персональных данных',
		url: 'https://files.rocketwork.ru/roketwork/Politika_obrabotki_PD.pdf',
		icon: 'shield',
	},
	{
		id: 'personal-data-terms',
		label: 'Условия предоставления персональных данных',
		url: 'https://files.rocketwork.ru/roketwork/Usloviya_predostavleniya_PD.pdf',
		icon: 'key',
	},
	{
		id: 'third-parties',
		label: 'Перечень третьих лиц для обработки данных',
		url: 'https://files.rocketwork.ru/roketwork/Perechen_tretih_lic_PD.pdf',
		icon: 'mask',
	},
];
